import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CertificateService from "../../services/CertificateService";
import GroupService from "../../services/GroupService";
import JournalService from "../../services/JournalService";

let initialState = {
    journals: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllJournals = createAsyncThunk(
    'getAllJournals',
    async ({page, limit, categoryId, archived}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await JournalService.getJournals(page, limit, categoryId, archived);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const journalListSlice = createSlice({
    name: 'journalListSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllJournals.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllJournals.fulfilled, (state, action) => {
                state.isLoading = false;
                state.journals = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllJournals.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.journals = [];
                state.hasMore = false;
            })
    }
});

export const {} = journalListSlice.actions;

export default journalListSlice.reducer;